// One source for how long a drawer's slide takes. `DrawerShell` publishes the
// millisecond value as this CSS custom property on its panel, so every
// transition inside a drawer reads it by inheritance and the JS timers that
// wait for those transitions to finish cannot drift from them.
export const DRAWER_TRANSITION_DURATION_MS = 300;

export const DRAWER_TRANSITION_DURATION_CSS_VAR = '--drawer-transition-duration';
